import { omit } from 'lodash';

import { mapColumnIdsAndNormalizedColumnIds, normalizeJsonObject } from '@backoffice/utils';
import translationsXlsConstants from '@commons/Excels/constants/translations.xlsx.constant';

export const formatTranslationsUpdateFile = (fileTranslationsData) => {
  const spSheetConfig = translationsXlsConstants.getSupplierProductSheetConfig();
  const ingredientsSheetConfig = translationsXlsConstants.getIngredientsSheetConfig();
  const recipesSheetConfig = translationsXlsConstants.getRecipesSheetConfig();
  const productsSheetConfig = translationsXlsConstants.getProductsSheetConfig();
  const categoriesSheetConfig = translationsXlsConstants.getCategoriesSheetConfig();
  const subCategoriesSheetConfig = translationsXlsConstants.getSubCategoriesSheetConfig();

  const formattedData = normalizeJsonObject(fileTranslationsData);

  return Object.keys(formattedData).reduce((result, sheetName) => {
    if (sheetName === spSheetConfig.SHEET.name) {
      result[spSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        // Spreading to get all the dynamic columns, omitting the normalized column to avoid duplicates
        ...omit(current, [
          spSheetConfig.COLUMNS_CONFIG.ID,
          spSheetConfig.COLUMNS_CONFIG.NAME,
          spSheetConfig.COLUMNS_CONFIG.PACKAGING_NAME_1,
          spSheetConfig.COLUMNS_CONFIG.PACKAGING_NAME_2,
          spSheetConfig.COLUMNS_CONFIG.PACKAGING_NAME_3,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          translationsXlsConstants.getNormalizedSupplierProductColumnIds(),
        ),
      }));
    }

    if (sheetName === ingredientsSheetConfig.SHEET.name) {
      result[ingredientsSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        ...omit(current, [
          ingredientsSheetConfig.COLUMNS_CONFIG.ID,
          ingredientsSheetConfig.COLUMNS_CONFIG.NAME,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          translationsXlsConstants.getNormalizedEntitiesAndProductsColumnIds(),
        ),
      }));
    }

    if (sheetName === recipesSheetConfig.SHEET.name) {
      result[recipesSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        ...omit(current, [
          recipesSheetConfig.COLUMNS_CONFIG.ID,
          recipesSheetConfig.COLUMNS_CONFIG.NAME,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          translationsXlsConstants.getNormalizedEntitiesAndProductsColumnIds(),
        ),
      }));
    }

    if (sheetName === productsSheetConfig.SHEET.name) {
      result[productsSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        ...omit(current, [
          productsSheetConfig.COLUMNS_CONFIG.ID,
          productsSheetConfig.COLUMNS_CONFIG.NAME,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          translationsXlsConstants.getNormalizedEntitiesAndProductsColumnIds(),
        ),
      }));
    }

    if (sheetName === categoriesSheetConfig.SHEET.name) {
      result[categoriesSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        ...omit(current, [
          categoriesSheetConfig.COLUMNS_CONFIG.ID,
          categoriesSheetConfig.COLUMNS_CONFIG.NAME,
          categoriesSheetConfig.COLUMNS_CONFIG.TYPE,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          translationsXlsConstants.getNormalizedCategoriesColumnIds(),
        ),
      }));
    }

    if (sheetName === subCategoriesSheetConfig.SHEET.name) {
      result[subCategoriesSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        ...omit(current, [
          subCategoriesSheetConfig.COLUMNS_CONFIG.ID,
          subCategoriesSheetConfig.COLUMNS_CONFIG.NAME,
          subCategoriesSheetConfig.COLUMNS_CONFIG.TYPE,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          translationsXlsConstants.getNormalizedSubCategoriesColumnIds(),
        ),
      }));
    }

    return result;
  }, {});
};

export default {
  formatTranslationsUpdateFile,
};
